import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="-49 141 512 512" {...props}>
      <title>{props.title || 'Chevron-Down'}</title>
      <g>
        <path d="M442.9 233.7l-189.5 189.5c-3.2 3.2-8.7 3.2-11.9 0l-189.5-189.5c-3.2-3.2-3.2-8.7 0-11.9l57.8-57.8c3.2-3.2 8.7-3.2 11.9 0l125.8 125.8 125.8-125.8c3.2-3.2 8.7-3.2 11.9 0l57.8 57.8c1.2 2 2.4 3.6 2.4 5.9-.1 2.5-.9 4-2.5 6z" />
      </g>
    </Icon>
  )
}
